<template>
  <v-dialog v-model="dialogVisible" 
    persistent max-width="360px"
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-title>
          Update Account Settings
        </v-card-title>

        <v-card-text>
          <div class="mt-2">
            <v-checkbox
              dense
              v-model="settings_expand_network"
              label="Expand Network"
            />
            <div>
              This feature will help you grow your pro list by sending referrals to nearby pros.
              Pros who claim your referrals are automatically added to your list.
              This is an excellent way to meet new Pros.
              Turn this off, and you'll only refer to pros who are already on your list.
            </div>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center py-4">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import { mapActions } from 'vuex'

  export default {
    name: 'AccountSettingsDialog',

    props: ['account'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,

        settings_expand_network: true,
      };
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.settings_expand_network = this.account.settings.expand_network
        }
      },
    },

    methods: {
      ...mapActions('accounts', ['updateMe']),
      
      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const payload = {
          settings_expand_network: this.settings_expand_network,
        }

        let result = await this.updateMe( payload)
        if( result.ok ) {
          this.close()
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>